module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "COPYRIGHT"
  }, [_vm._v("First edition © 1991 Wm. B. Eerdmans Publishing Co."), _c('br'), _vm._v("Second edition © 2004 Wm. B. Eerdmans Publishing Co."), _c('br'), _vm._v("This third edition © 2014 Daniel L. Migliore"), _c('br'), _vm._v("All rights reserved"), _c('br'), _c('br'), _vm._v("Published 2014 by"), _c('br'), _vm._v("Wm. B. Eerdmans Publishing Co."), _c('br'), _vm._v("2140 Oak Industrial Drive N.E., Grand Rapids, Michigan 49505 /"), _c('br'), _vm._v("P.O. Box 163, Cambridge CB3 9PU U.K."), _c('br'), _c('br'), _vm._v("Printed in the United States of America")]), _vm._v(" "), _c('p', {
    staticClass: "LIBRARY"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "CIP"
  }, [_vm._v("Migliore, Daniel L., 1935- author."), _c('br'), _vm._v("Faith seeking understanding: an introduction to Christian theology /"), _c('br'), _vm._v("Daniel L. Migliore. — Third edition."), _c('br'), _vm._v("pages   cm"), _c('br'), _vm._v("ISBN 978-0-8028-7185-5 (pbk.: alk. paper)"), _c('br'), _vm._v("ISBN 978-1-4674-4221-3 (ePub)"), _c('br'), _vm._v("ISBN 978-1-4674-4187-2 (Kindle)"), _c('br'), _vm._v("1. Theology, Doctrinal. I. Title."), _c('br'), _c('br'), _vm._v("BT65.M54 2014"), _c('br'), _vm._v("230 — dc23"), _c('br'), _vm._v("                       2014012176")]), _vm._v(" "), _c('p', {
    staticClass: "URL"
  }, [_c('a', {
    attrs: {
      "href": "http://www.eerdmans.com",
      "target": "_blank"
    }
  }, [_vm._v("www.eerdmans.com")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24827a40","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Copyright.vue
// module id = 60
// module chunks = 0